import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image";

import Logo from '../Logo';

import * as S from './styles';

export default function Header() {
  const [isNavMobOpen, setIsNavMobOpen] = React.useState(false);
  return (
    <S.Header>
      <S.Container>
        <Logo />
        <S.Nav>
          <ul>
            <li><Link rel="noreferrer" to="#">Pricing</Link></li>
            <li><Link rel="noreferrer" to="#">Features</Link></li>
            <li><Link rel="noreferrer" to="#">About</Link></li>
            <li><Link rel="noreferrer" to="#">Login</Link></li>
            <li className="spotlight"><Link rel="noreferrer" to="#">Sign up</Link></li>
          </ul>
        </S.Nav>
        <S.DivNavMobile>
          <S.BtnMobile onClick={() => setIsNavMobOpen(true)} isOpen={!isNavMobOpen}>
            {/* <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="12" y="20" width="24" height="2" fill="var(--black)"></rect><rect x="20" y="26" width="16" height="2" fill="var(--black)"></rect></svg> */}
            <StaticImage
              src={`../../images/menu.png`}
              alt="Menu Navbar open"
              placeholder="blurred"
              layout="fixed"
              width={30}
              height={30}
            />
          </S.BtnMobile>
        </S.DivNavMobile>
      </S.Container>
      <S.NavMobile isOpen={isNavMobOpen}>
        <Logo />
        <ul>
          <li><Link to="/">Home</Link></li>
          <li><Link rel="noreferrer" to="#">Pricing</Link></li>
          <li><Link rel="noreferrer" to="#">Features</Link></li>
          <li><Link rel="noreferrer" to="#">About</Link></li>
          <li><Link rel="noreferrer" to="#">Login</Link></li>
          <li className="spotlight"><Link rel="noreferrer" to="#">Sign up</Link></li>
        </ul>
        {/* <S.BtnMobileClose onClick={() => setIsNavMobOpen(false)}>Close</S.BtnMobileClose> */}
      </S.NavMobile>
      <S.Background isOpen={isNavMobOpen}>
        <S.BackgroundClose onClick={() => setIsNavMobOpen(false)}>
          <StaticImage
            src={`../../images/close.png`}
            alt="Menu navbar close"
            placeholder="blurred"
            layout="fixed"
            width={30}
            height={30}
          />
        </S.BackgroundClose>
      </S.Background>
    </S.Header>
  )
}